import React, { useState } from "react";
import cn from "classnames";
import { ReactComponent as MinusButtonIcon } from "static/images/minus-button.svg";
import { ReactComponent as PlusButtonIcon } from "static/images/plus-button.svg";
import "styles/ui/counter-input.scss";

import A11yElement from "components/helpers/A11yElement";

const CounterInput = ({
  className,
  initial = 1,
  min = 0,
  max = 50,
  name = "counter",
  label = name,
  onChange,
  ariaDescribedBy,
}) => {
  const [hasChanged, setHasChanged] = useState(false);
  const [value, setValue] = useState(initial);
  const onClick = delta => e => {
    if (value + delta >= min && value + delta <= max) {
      setValue(value + delta);
      setHasChanged(true);
      if (typeof onChange === "function") {
        onChange(value + delta);
      }
    }
  };

  return (
    <div className={cn("otrl-jp__counter-input", className)}>
      {/* <div
        className={cn("otrl-jp__counter-input__button", {
          "otrl-jp__counter-input__button--disabled": value === min
        })}
        onClick={onClick(-1)}
      >
        &#8722;
      </div> */}
      <button
        className="otrl-jp__button-unstyled"
        onClick={onClick(-1)}
        aria-label={`Decrease ${label}`}
        type="button"
      >
        <MinusButtonIcon
          className={cn("otrl-jp__counter-input__button", {
            "otrl-jp__counter-input__button--disabled": value === min,
          })}
        />
      </button>

      <A11yElement
        as="input"
        onArrowLeftDown={onClick(-1)}
        onArrowRightTop={onClick(1)}
        aria-describedby={ariaDescribedBy}
        aria-live={hasChanged ? "polite" : undefined}
        className="otrl-jp__counter-input__input"
        data-lpignore="true"
        type="text"
        name={name}
        tabIndex="-1"
        readOnly
        value={value}
    />
      <button
        className="otrl-jp__button-unstyled"
        onClick={onClick(1)}
        aria-label={`Increase ${label}`}
        type="button"
      >
        <PlusButtonIcon
          className={cn("otrl-jp__counter-input__button", {
            "otrl-jp__counter-input__button--disabled": value === max,
          })}
        />
      </button>
      {/* <div
        className={cn("otrl-jp__counter-input__button", {
          "otrl-jp__counter-input__button--disabled": value === max
        })}
        onClick={onClick(1)}
      > */}
      {/* + */}
      {/* </div> */}
    </div>
  );
};

export default CounterInput;
